import React from "react";
import styles from "./Button.module.css";

const Button = ({ children, className, ...props }) => {
  return (
    <button className={`${styles.btn} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;
